import "./style.scss";
const InputErrorMsg = ({errMsg}) => {
  return <div className="input-err-msg">{errMsg}</div>;
};

export default InputErrorMsg;
